/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { Component, Inject, Optional, Input, Output, EventEmitter } from '@angular/core';

import { IDialogData } from '../../models/interfaces/IDialogData';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';


@Component({
  selector: 'app-dialog-box',
  templateUrl: './dialog-box.component.html'
})
export class DialogBoxComponent {


  okClickEvent = new EventEmitter();
  cancelClickEvent = new EventEmitter();

  constructor(public dialogRef: MatDialogRef<DialogBoxComponent>, @Inject(MAT_DIALOG_DATA) public data: IDialogData) { }

  onOkClick() {
    this.okClickEvent.emit();
    this.dialogRef.close();
  }

  onCancelClick() {
    this.cancelClickEvent.emit();
    this.dialogRef.close();
  }

}
